import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import "./index.css";
import App from "./App";
import {applyLook, savedLook} from "./shared/utils/look";
import {applyTheme, savedTheme} from "./shared/utils/theme";

// Before the first render, so the page never flashes the default color.
applyTheme(savedTheme());
applyLook(savedLook());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
